import { render, staticRenderFns } from "./index.vue?vue&type=template&id=391f70df&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=391f70df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391f70df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('391f70df')) {
      api.createRecord('391f70df', component.options)
    } else {
      api.reload('391f70df', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=391f70df&scoped=true&", function () {
      api.rerender('391f70df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/city-cost-review/modules/editConfig/index.vue"
export default component.exports